import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Collapse } from "reactstrap";

// images
import Dashlogo from "../../assets/images/jamme_logo.svg";
import Logocollapse from "../../assets/images/logocollapse.png";

import AppIntroLogo from "assets/images/AppIntroLogo";
import { useSelector } from "react-redux";
import Chatroomicon from "../../assets/svg/chatroom_icon.svg";
import Cmsicon from "../../assets/svg/cms_icon.svg";
import Customericon from "../../assets/svg/customer_icon.svg";
import Dashicon from "../../assets/svg/dash_icon.svg";
import Dataicon from "../../assets/svg/data_icon.svg";
import Eventicon from "../../assets/svg/event_icon.svg";
import Notiicon from "../../assets/svg/noti_icon.svg";
import Pendingeq from "../../assets/svg/pending_req.png";
import Subadminicon from "../../assets/svg/sub_admin_icon.svg";
import Usericon from "../../assets/svg/user_icon.svg";
import {
  PendingPermissionKeys,
  PERMISSION_KEYS,
} from "utilities/permissionConst";

const sidebarItems = [
  {
    type: "link",
    to: "/",
    icon: Dashicon,
    title: "Dashboard",
    label: "Dashboard",
    permissionKey: PERMISSION_KEYS.DASHBOARD,
  },
  {
    type: "submenu",
    subMenuKey: "pendingRequest",
    icon: Pendingeq,
    title: "Pending Requests",
    label: "Pending Requests",
    permissionKey: PERMISSION_KEYS.PENDING_REQUEST_MODULE,
    children: [
      {
        to: "/pending-users",
        title: "Users",
        label: "Users",
        permissionKey: PERMISSION_KEYS.PENDING_USERS,
      },
      {
        to: "/change-role-request",
        title: "Change Role Request",
        label: "Change Role Request",
        permissionKey: PERMISSION_KEYS.CHANGE_ROLE_REQUEST,
      },
      {
        to: "/pending-pitches",
        title: "Pitches",
        label: "Pitches",
        permissionKey: PERMISSION_KEYS.PENDING_PITCHES,
      },
      {
        to: "/pending-posts",
        title: "Posts",
        label: "Posts",
        permissionKey: PERMISSION_KEYS.PENDING_POSTS,
      },
      {
        to: "/pending-events",
        title: "Events",
        label: "Events",
        permissionKey: PERMISSION_KEYS.PENDING_EVENTS,
      },
      {
        to: "/pending-request-chatroom",
        title: "Chatrooms",
        label: "Chatrooms",
        permissionKey: PERMISSION_KEYS.PENDING_CHATROOM,
      },
    ],
  },
  {
    type: "link",
    to: "/manage-users",
    icon: Usericon,
    title: "Users",
    label: "Users",
    permissionKey: PERMISSION_KEYS.USER_PERMISSION,
  },
  {
    type: "link",
    to: "/events",
    icon: Eventicon,
    title: "Events",
    label: "Events",
    permissionKey: PERMISSION_KEYS.EVENT_PERMISSION,
  },
  {
    type: "link",
    to: "/pitches",
    icon: Eventicon,
    title: "Pitch",
    label: "Pitch",
    permissionKey: PERMISSION_KEYS.PITCH_PERMISSION,
  },
  {
    type: "link",
    to: "/posts",
    icon: Eventicon,
    title: "Posts",
    label: "Posts",
    permissionKey: PERMISSION_KEYS.POST_PERMISSION,
  },
  {
    type: "link",
    to: "/talent",
    icon: Cmsicon,
    title: "Talent",
    label: "Talent",
    permissionKey: PERMISSION_KEYS.TALENT_PERMISSION,
  },
  {
    type: "link",
    to: "/speciality",
    icon: Cmsicon,
    title: "Speciality",
    label: "Speciality",
    permissionKey: PERMISSION_KEYS.SPECIALITY_PERMISSION,
  },
  {
    type: "link",
    to: "/category",
    icon: Cmsicon,
    title: "Category",
    label: "Category",
    permissionKey: PERMISSION_KEYS.CATEGORY_PERMISSION,
  },
  {
    type: "link",
    to: "/chatroom",
    icon: Chatroomicon,
    title: "Chatroom",
    label: "Chatroom",
    permissionKey: PERMISSION_KEYS.CHATROOM_PERMISSION,
  },
  {
    type: "submenu",
    subMenuKey: "support",
    icon: Chatroomicon,
    title: "Support",
    label: "Support",
    permissionKey: PERMISSION_KEYS.CUSTOMER_SUPPORT_PERMISSION,
    children: [
      {
        to: "/chat-support",
        title: "Users",
        label: "Support Chat",
        permissionKey: PERMISSION_KEYS.CUSTOMER_SUPPORT_PERMISSION,
      },
      {
        to: "/support-issues",
        title: "Support Categories",
        label: "Support Categories",
        permissionKey: PERMISSION_KEYS.CUSTOMER_SUPPORT_PERMISSION,
      },
      {
        to: "/customer-support",
        title: "Support Cases",
        label: "Support Cases",
        permissionKey: PERMISSION_KEYS.CUSTOMER_SUPPORT_PERMISSION,
      },
    ],
  },
  {
    type: "link",
    to: "/sub-admin",
    icon: Subadminicon,
    title: "Sub-Admin",
    label: "Sub-Admin",
    permissionKey: PERMISSION_KEYS.SUB_ADMIN_PERMISSION,
  },
  {
    type: "link",
    to: "/all-notification",
    icon: Notiicon,
    title: "Notification",
    label: "Notification",
    permissionKey: PERMISSION_KEYS.NOTIFICATION_PERMISSION,
  },
  {
    type: "link",
    to: "/data-analytics",
    icon: Dataicon,
    title: "Data & Analytics",
    label: "Data & Analytics",
    permissionKey: PERMISSION_KEYS.DATA_ANALYTICS_PERMISSION,
  },
  {
    type: "link",
    to: "/customer-feedback",
    icon: Customericon,
    title: "Customer Feedback",
    label: "Customer Feedback",
    permissionKey: PERMISSION_KEYS.CUSTOMER_FEEDBACK_PERMISSION,
  },
  {
    type: "link",
    to: "/app-intro",
    iconComponent: AppIntroLogo,
    title: "App Intro",
    label: "App Intro",
    permissionKey: PERMISSION_KEYS.APP_INTRO_PERMISSION,
  },
  {
    type: "submenu",
    subMenuKey: "reports",
    icon: Chatroomicon,
    title: "Reports",
    label: "Reports",
    permissionKey: PERMISSION_KEYS.REPORT_USER_PERMISSION,
    children: [
      {
        to: "/report-user",
        title: "Users",
        label: "Reported",
        permissionKey: PERMISSION_KEYS.REPORT_USER_PERMISSION,
      },
      {
        to: "/report-issues",
        permissionKey: PERMISSION_KEYS.REPORT_USER_PERMISSION,
        title: "Report Categories",
        label: "Report Categories",
      },
    ],
  },
  {
    type: "link",
    to: "/cms",
    icon: Cmsicon,
    title: "CMS Pages",
    label: "CMS Pages",
    permissionKey: PERMISSION_KEYS.CMS_ADMIN_PERMISSION,
  },
];

const Profilesidebar = (props) => {
  const [subMenu, setSubMenu] = useState({
    pendingRequest: false,
    support: false,
    reports: false,
  });

  const permission = useSelector((s) => s?.profileData);
  const role = useSelector((s) => s?.login?.role);

  const toggleSubMenu = (key) => {
    const newObj = {};
    const oldSubMenuSTatus = subMenu[key];
    Object.keys(subMenu).forEach((item) => {
      newObj[item] = false;
    });
    newObj[key] = !oldSubMenuSTatus;
    setSubMenu(newObj);
  };

  const renderIcon = (item) => {
    if (item.iconComponent) {
      return <item.iconComponent />;
    }
    return (
      <img src={item.icon} alt="" className="img-fluid" title={item.title} />
    );
  };

  const shouldShowItem = (item) => {
    if (role == "1" || item.permissionKey === "dashboard") return true;

    if (
      PendingPermissionKeys.includes(item.permissionKey) &&
      !permission.pendingRequestSubViewNames.includes(item.permissionKey)
    ) {
      return false;
    } else if (
      !PendingPermissionKeys.includes(item.permissionKey) &&
      !permission[item.permissionKey]?.isView
    ) {
      return false;
    }

    return true;
  };

  return (
    <section className="profile_side">
      <div className="profile_side_inner position-relative">
        {props.sidebarHidden ? (
          <Link to="/">
            <div className="dashlogocollapse px-0 pt-3 pb-0">
              <img src={Logocollapse} alt="" className="img-fluid" />
            </div>
          </Link>
        ) : (
          <Link to="/">
            <div className="dashlogo">
              <img src={Dashlogo} alt="" className="img-fluid" />
            </div>
          </Link>
        )}

        <ul className="dash_nav position-relative" id="side-menu">
          {sidebarItems.map((item) => {
            if (item.type === "submenu") {
              const isshouldShowItem = shouldShowItem(item);
              if (!isshouldShowItem) return null;
              return (
                <li key={item.subMenuKey}>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    onClick={() => toggleSubMenu(item.subMenuKey)}
                    aria-expanded={subMenu[item.subMenuKey]}
                    aria-controls="collapsepatinets"
                  >
                    <span className="icon-right">{renderIcon(item)}</span>
                    {item.label}
                  </Link>
                  <Collapse
                    isOpen={subMenu[item.subMenuKey]}
                    id="collapsepatinets"
                  >
                    <ul className="submenu">
                      {item.children.map((child) => {
                        const isshouldShowChild = shouldShowItem(child);
                        if (!isshouldShowChild) return null;
                        return (
                          <li key={child.to}>
                            <NavLink to={child.to} title={child.title}>
                              {child.label}
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  </Collapse>
                </li>
              );
            }

            const isshouldShowItem = shouldShowItem(item);

            if (!isshouldShowItem) return null;

            return (
              <li key={item.to}>
                <NavLink to={item.to} className="btn btn-primary">
                  <span className="icon-right">{renderIcon(item)}</span>
                  {item.label}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Profilesidebar;
